import type { ZipValidationModel } from 'entities/campaign';

import { ZipsResultsModal } from './ZipsResultsModal';
import { ZipsResultsBlock } from './ZipResultsBlock';

export interface ZipsResultsModalCampaignProps {
  campaignId: number;
  zipValidationData: ZipValidationModel;
  modalProps?: {
    title?: string;
    subtitle?: string;
    buttonText?: string;
  };
}

export function ZipsResultsModalCampaign({ campaignId, zipValidationData, modalProps }: ZipsResultsModalCampaignProps) {
  return (
    <ZipsResultsModal
      zipValidationData={zipValidationData}
      zipResults={
        <ZipsResultsBlock
          campaignId={campaignId}
          validCount={zipValidationData.validCount}
          duplicateCount={zipValidationData.duplicateCount}
          invalidCount={zipValidationData.invalidCount}
        />
      }
      modalProps={{
        title: 'Edit target area',
        subtitle:
          'Please double-check the target area validation results. Duplicates and incorrect ZIP Codes (errors) will be not added to your campaign.',
        buttonText: 'Update ZIPs',
        autoTestAttributesName: 'zips-result-campaign-modal',
        ...modalProps,
      }}
    />
  );
}
